import styled from 'styled-components';
import { Col, Row } from 'antd';

import { ITestimonial } from '../../common/model/testimonial.model';
import useI18n from '../../common/hooks/useI18n';

import SectionTitle from './sectionTitle';
import Video from './video';
import { TestimonialsCarousel } from '../shared';

type Props = {
  query: string;
  testimonials: ITestimonial[];
};

const Subtitle = styled.div`
  max-width: 80%;
  font-size: 18px;
  line-height: 32px;
  margin-bottom: 32px;

  @media ${(props) => props.theme.breakpoints.lgd} {
    font-size: 16px;
  }
  @media ${(props) => props.theme.breakpoints.smd} {
    max-width: unset;
    line-height: 22px;
  }
`;

const TestimonialsSection: React.FC<Props> = ({ query, testimonials }) => {
  const i18n = useI18n();

  return (
    <>
      <SectionTitle
        title={i18n.t(`dynamic.sellHousePage.${query}.testimonialsVideoTitle`)}
      />
      <Subtitle>
        {i18n.t(`dynamic.sellHousePage.${query}.testimonialsVideoSubtitle`)}
      </Subtitle>

      <Row gutter={[48, 24]} align="middle">
        <Col xs={24} md={16}>
          <Video
            url={i18n.t(`dynamic.sellHousePage.${query}.testimonialsVideoUrl`)}
          />
        </Col>
        <Col xs={24} md={8}>
          <TestimonialsCarousel testimonials={testimonials} reducedWidth />
        </Col>
      </Row>
    </>
  );
};

export default TestimonialsSection;
